import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKey = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5 13C11.9062 13 11.3438 12.9375 10.8125 12.75L9.78125 13.7812C9.625 13.9375 9.4375 14 9.25 14H8V15.25C8 15.6875 7.65625 16 7.25 16H6V17.25C6 17.6875 5.65625 18 5.25 18H2.75C2.3125 18 2 17.6875 2 17.25V14.75C2 14.5625 2.0625 14.375 2.21875 14.2188L7.25 9.1875C7.0625 8.65625 7 8.09375 7 7.5C7 4.46875 9.4375 2 12.5 2C15.5312 2 18 4.46875 18 7.5C18 10.5625 15.5312 13 12.5 13ZM13.75 5C13.2812 5 12.875 5.25 12.6562 5.625C12.4375 6.03125 12.4375 6.5 12.6562 6.875C12.875 7.28125 13.2812 7.5 13.75 7.5C14.1875 7.5 14.5938 7.28125 14.8125 6.875C15.0312 6.5 15.0312 6.03125 14.8125 5.625C14.5938 5.25 14.1875 5 13.75 5Z",
		fill: "#0D2976"
	})
});
export default SvgKey;
